<template>
  <div>
    <div class="successPrompt">
      <i class="el-icon-success"></i>
      <div class="bindPrompt">银行卡已成功绑定</div>
    </div>
    <div class="styleSet">
      <el-form style="width: 90%;" :label-width="labelWidth+'px'" :model="step3Form" inline  ref="step3Form">
        <el-col :span="12">
          <el-form-item :label="labelNames.accountIdName" prop="accountId">
            <div>{{this.step3Form.accountId}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="labelNames.merchantNameFn" prop="merchantName">
            <div>{{this.step3Form.merchantName}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="bankCardNo" :label="labelNames.bankCardNoName">
            <div>{{this.step3Form.bankCardNo}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="bankShortName" label="开户行名称:">
            <div>{{this.step3Form.bankShortName}}</div>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>
</template>
<script>
import config from './config'

export default {
  props: {
    stepsParams: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    const { labelNames } = config.call(this)
    return {
      labelNames,
      labelWidth: 170,
      step3Form: {
        accountId: '',
        merchantName: '',
        bankCardNo: '',
        bankShortName: ''
      }
    }
  },
  created () {
    if (this.stepsParams) {
      this.step3Form.accountId = this.stepsParams.accountId
      this.step3Form.merchantName = this.stepsParams.merchantName
      this.step3Form.bankCardNo = this.stepsParams.bankCardNo
      this.step3Form.bankShortName = this.stepsParams.selectedOption
    }
    if (this.$route.query) {
      this.origin = this.$route.query.origin || ''
    }
  },
}
</script>
<style scoped lang="scss">
.styleSet{
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.successPrompt {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
}
.bindPrompt{
  display: flex;
  font-size: 18px;
  color: black;
  text-align: center;
  margin-left: 10px;
}
.el-icon-success:before {
  color: #32B754;
  font-size: 30px;
}
.sureStyleSet{
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 50px;
}
</style>

